import { combineReducers } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import bannerSlice from './slices/bannerSlice';
import detailsReducer from './slices/detailsSlice';
import usersReducer from './slices/usersSlice';
import verifyContactSlice from './slices/verifyContactSlice';
import navigationReducer from './slices/navigationSlice';
import { AppDispatch } from './store';

const rootReducer = combineReducers({
  users: usersReducer,
  details: detailsReducer,
  banner: bannerSlice,
  verifyContact: verifyContactSlice,
  mainNavigation: navigationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default rootReducer;
